import { ApiUtility } from "../../Utilities/ApiUtility.axios";
import { Product_Module } from "./ClientService";
import { LedgerStatus, SearchLedgerByGroupsTypes } from "./LedgerService";

export enum Statements {
  Trading = 1,
  ProfitAndLoss = 2,
  BalanceSheet = 3,
}
export enum GroupTypes {
  Primary = 1,
  Secondary = 2,
}
export enum Nature_new {
  DirectExpenses = 1,
  DirectIncome = 2,
  IndirectExpenses = 3,
  IndirectIncome = 4,
  Assets = 5,
  Liabilities = 6,
}

export enum Default_Groups {
  Self = 0,
  PurchaseAccount,
  DirectExpenses,
  DirectIncomes,
  SalesAccounts,
  IndirectExpenses,
  IndirectIncomes,
  FixedAssets,
  Investments,
  LoansAdvancesAsset,
  MiscExpensesAsset,
  CurrentAssets,
  StockInHand,
  SundryDebtors,
  DepositsAsset,
  BankAccounts,
  CashInHand,
  CapitalAccount,
  LoansLiability,
  ReservesSurplus,
  SecuredLoans,
  UnsecuredLoans,
  CurrentLiabilities,
  SundryCreditors,
  BankOD,
  DutiesTaxes,
  Provisions,
  Suspense,
}

//  not taken for now enum
export enum NewCompanyType {
  All = 0,
  Customer = 1,
  Supplier = 2,
}

export enum BusinessTypes {
  PrivateLimited,
  PublicLimited,
  SoleProprietorship,
  Partnership,
  LLP,
  LLC,
  JointVenture,
  NGO,
}

class ChartofAccountServiceNew {
  route = `V1/API/Billing/Acc_New_Group`;

  // ----- Group Services(Api) -----
  getGroupList = (
    companyId: string,
    module?: Product_Module,
    search?: string,
    sortCol?: string,
    sortDir?: string,
    //GroupType?: GroupTypes,
    //sGroupName?: string,
    //sAliasName?: string,
    // sOrder?: string,
    groupId?: string,
    groupSelType?: SearchLedgerByGroupsTypes,
    groupSearch?: string,
    status?: LedgerStatus,
    start: number = 0,
    length: number = 0
  ) =>
    ApiUtility.getResult(`${this.route}/${companyId}/GetList`, {
      module,
      search,
      sortCol,
      sortDir,
      //GroupType,
      // sGroupName,
      //sAliasName,
      // sOrder,
      groupId,
      groupSelType,
      groupSearch,
      status,
      start,
      length,
    });

  postGroup = (companyId: string, params: any, id?: string) =>
    ApiUtility.post(`${this.route}/${companyId}/${id ? id : ""}`, params);
  // delete Api
  // https://localhost:7142/v1/API/65cdd05235241f48a55de738/Delete/6633996dfc3a199983c6c8a8

  setActiveDeactiveGroup = (companyId: string, groupId: string) =>
    ApiUtility.post(
      `${this.route}/${companyId}/SetActiveDeactive/${groupId}`,
      null
    );
}
export default new ChartofAccountServiceNew();
